<div id="familyJuncture" class="container">
    <div *ngIf="this.linkTypeFlag">
        <div class="row content" *ngIf="!this.FlagService.flagServiceObject[3]['userdataJunctureFlag']">
            <div class="col-12 p-0">
                <div class="component-header __indicator">
                    <h3 class="label m-0">{{ 'junctures.family.header' | translate }}</h3>
                </div>
            </div>

            <div class="col-12">
                <div class="title">
                    <fa-icon class="faPropleArrows" [icon]="faPropleArrows"></fa-icon>
                    <h3>{{ 'junctures.family.access' | translate }}</h3>
                </div>

                <div class="col-12 input-group" *ngIf="this.familyCaptchaCountdown < 3">
                    <span class="info">{{ 'junctures.family.info' | translate: { contractorName, customerType } }}</span>
                    <br>
                    <label class="form-label mt-3" for="familyMemberName">{{ 'junctures.family.name' | translate }}</label>
                    <input id="familyMemberName" class="form-control" type="text" [(ngModel)]="_familyMemberNameInput" (ngModelChange)="inputChange()" name="family-member-name" placeholder="{{ 'junctures.family.placeholder.name' | translate }}">

                    <label class="form-label" for="birthDate">{{ 'junctures.family.birthDate' | translate }}</label>
                    <div class="birth-year-selection">
                        <select class="form-select birth-year" aria-label="Birth year select" [(ngModel)]="_birthYear" (ngModelChange)="inputChange()">
                            <option *ngFor="let year of DataService.availableYears" value="{{ year }}">
                                {{ year }}
                            </option>
                        </select>
                        <select class="form-select birth-month" aria-label="Birth month select" [(ngModel)]="_birthMonth" (ngModelChange)="inputChange()">
                            <option *ngFor="let month of generalUtils.getMonths()" value="{{ month }}">
                                {{ ('common.month.' + month) | translate }}
                            </option>
                        </select>
                        <select class="form-select birth-day" aria-label="Birth day select" [(ngModel)]="_birthDay" (ngModelChange)="inputChange()">
                            <option *ngFor="let day of generalUtils.getDays() | keyvalue" value="{{ day.key }}">
                                {{ day.value }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="d-flex summary mt-4" *ngIf="this.summaryFlag && this.familyCaptchaCountdown < 3">
                    <div class="w-100">
                        <fa-icon class="text-center me-2" [icon]="faPropleArrows"></fa-icon>
                        <div class="text">
                            <span class="name">{{_familyMemberNameInput}}</span><br>
                            <span class="date">{{_familyMemberBirthDate}}</span>
                        </div>
                    </div>

                    <div class="flex-shrink-1">
                        <button (click)="sendFamilyMember()" type="button" class="btn btn-light float-end">Ok</button>
                    </div>
                </div>

                <div class="captcha" *ngIf="!(this.familyCaptchaCountdown < 3)">
                    <div class="row justify-content-md-center mb-4 mt-2">
                        <div class="col-sm-10 col-md-8 mb-1 text-center">
                            <img *ngIf='this.captchaPath' [src]="this.captchaPath" alt="captcha image" title="captcha image">
                            <fa-icon *ngIf='!this.captchaPath' class="faHourglass mb-3" [icon]="faHourglass"></fa-icon>
                        </div>
                        <div class="col-sm-10 col-md-8">
                            <div class="captcha-container mt-1">
                                <input id="captchaInput" class="form-control" type="text" name="captcha" placeholder="{{ 'junctures.family.placeholder.captcha' | translate }}" (ngModelChange)="captchaInputChange($event)" [(ngModel)]="_captchaInput" [attr.disabled]="this.captchaPath? null : true">
                                <button (click)="validateCaptcha()" type="button" class="btn ms-3" [ngClass]="{'disabled': !_captchaInputValid}">{{ 'common.ok' | translate }}</button>
                                <button *ngIf='this.captchaPath' (click)="reloadCaptcha()" type="button" class="btn ms-2"><fa-icon class="faRedo" [icon]="faRedo"></fa-icon></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row feedback-module" *ngIf="this.FlagService.flagServiceObject[3]['userdataJunctureFlag']" (click)="familyJunctureClick()">
                <div class="d-flex p-0">
                    <a class="w-100">
                        <fa-icon class="text-center ms-3 me-3" [icon]="faPropleArrows"></fa-icon>
                        <div class="text">
                            <span class="top">{{ this.insurantData.employee.name }}</span><br>
                            <span class="bottom">{{ this.insurantData.employee.birthDate }}</span>
                        </div>
                    </a>

                    <div *ngIf="false" class="flex-shrink-1">
                        <fa-icon class="faInfoCircle me-2" [icon]="faInfoCircle"></fa-icon>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="!this.linkTypeFlag">
        <div class="row content" *ngIf="!this.FlagService.flagServiceObject[3]['userdataJunctureFlag']">
            <div class="col-12 p-0">
                <div class="component-header __indicator">
                    <h3 class="label m-0">{{ 'junctures.family.couponCode.header' | translate }}</h3>
                </div>
            </div>
            <div class="d-flex summary align-center code-text-container" style="background-color: white" *ngIf="(this.couponCaptchaCountdown < 3)">
              <div class="w-100 flex code-text">
                {{ 'junctures.family.couponCode.info' | translate }}
              </div>
              <div class="w-100 flex hover-blue">
                <fa-icon class="text-center me-2" [icon]="faStar"></fa-icon>
                <div class="text">
                  <input id="couponCode" class="form-control" type="text" [(ngModel)]="_couponCodeInput" (ngModelChange)="checkCode()" name="coupon-code" placeholder="{{ 'junctures.family.couponCode.placeholder' | translate }}">
                  <div class="feedback invalid-feedback" *ngIf="errorMessage"><span class="wrap">{{ errorMessage }}</span></div>
                </div>
                <div class="flex-shrink-1">
                  <button (click)="sendCouponCode('code')" type="button" class="btn btn-light float-end" style="margin-top: 0.6rem">{{ 'common.ok' | translate }}</button>
                </div>
              </div>
            </div>

            <div class="code-separator"></div>

            <div class="d-flex summary align-center pointer no-code-container" *ngIf="(this.couponCaptchaCountdown < 3)" (click)="sendCouponCode('none')">
                <div class="w-100 flex hover-blue">
                    <fa-icon class="text-center me-2" [icon]="faRegStar"></fa-icon>
                    <div class="text">
                        <span class="name">{{ 'junctures.family.couponCode.noCode' | translate }}</span><br>
                    </div>
                </div>
            </div>

            <div class="captcha" *ngIf="!(this.couponCaptchaCountdown < 3)">
                <div class="row justify-content-md-center mb-4 mt-5">
                    <div class="col-sm-10 col-md-8 mb-1 text-center">
                        <img *ngIf='this.captchaPath' [src]="this.captchaPath" alt="captcha image" title="captcha image">
                        <fa-icon *ngIf='!this.captchaPath' class="faHourglass mb-3" [icon]="faHourglass"></fa-icon>
                    </div>
                    <div class="col-sm-10 col-md-8">
                        <div class="captcha-container mt-1">
                            <input id="captchaInput" class="form-control" type="text" name="captcha" placeholder="{{ 'junctures.family.couponCode.placeholder' | translate }}" (ngModelChange)="captchaInputChange($event)" [(ngModel)]="_captchaInput" [attr.disabled]="this.captchaPath? null : true">
                            <button (click)="validateCaptcha()" type="button" class="btn ms-3" [ngClass]="{'disabled': !_captchaInputValid}">{{ 'common.ok' | translate }}</button>
                            <button *ngIf='this.captchaPath' (click)="reloadCaptcha()" type="button" class="btn ms-2"><fa-icon class="faRedo" [icon]="faRedo"></fa-icon></button>
                        </div>
                      <div class="feedback invalid-feedback" *ngIf="captchaMessage"><span class="wrap">{{ captchaMessage }}</span></div>
                    </div>
                </div>
            </div>
        </div>

      <ng-container *ngIf="!(DataService.isPartneri && DataService.isKompakt())">
        <div class="row feedback-module" *ngIf="this.FlagService.flagServiceObject[3]['userdataJunctureFlag']" (click)="familyJunctureClick()">
            <div class="d-flex p-0">
                <a class="w-100">
                    <fa-icon class="text-center ms-3 me-3" [icon]="faStar"></fa-icon>
                    <div class="text">
                        <span class="top">{{ 'junctures.family.couponCode.code' | translate }}</span><br>
                        <span *ngIf="this.DataService.HIPInsuredPersonFromHIPDto.couponCode" class="bottom">{{this.DataService.HIPInsuredPersonFromHIPDto.couponCode}}</span>
                        <span *ngIf="!this.DataService.HIPInsuredPersonFromHIPDto.couponCode" class="bottom">{{_couponCodeInput}}</span>
                        <span *ngIf="!this.DataService.HIPInsuredPersonFromHIPDto.couponCode && this._couponCodeInput.length == 0" class="bottom">{{ 'junctures.family.couponCode.status' | translate }}</span>
                    </div>
                </a>

                <div *ngIf="false" class="flex-shrink-1">
                    <fa-icon class="faInfoCircle me-2" [icon]="faInfoCircle"></fa-icon>
                </div>
            </div>
        </div>
      </ng-container>
    </div>
</div>
